import React, { lazy, Component } from 'react';
import { CheckCircleIcon } from 'lucide-react';
// Componente de imagen con lazy loading
const LazyImage = ({
  src,
  alt,
  className
}) => {
  return <img src={src} alt={alt} className={className} loading="lazy" data-id="element-222" />;
};
export function PainPoints() {
  return <section id="beneficios" className="py-16 bg-amber-100" data-id="element-223">
      <div className="container mx-auto px-4" data-id="element-224">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-225">
          <div className="flex-1" data-id="element-226">
            <LazyImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/urnT29816pGj1yprXnxsFi/Generated_Image_September_11%2C_2025_-_3_17PM.png" alt="Mamá cocinando con su hija" className="w-full rounded-lg shadow-lg" data-id="element-227" />
          </div>
          <div className="flex-1" data-id="element-228">
            <h2 className="text-3xl font-bold text-amber-800 mb-6" data-id="element-229">
              ¿Te suena familiar?
            </h2>
            <div className="space-y-4 mb-8" data-id="element-230">
              <PainPoint text="Son las 7 PM y no sabes qué cocinar." data-id="element-231" />
              <PainPoint text="Tus hijos ya tienen hambre, pero lo único rápido es comida chatarra." data-id="element-232" />
              <PainPoint text="Abres la nevera y suspiras… otra vez lo mismo." data-id="element-233" />
            </div>
            <h3 className="text-2xl font-semibold text-amber-800 mb-4" data-id="element-234">
              Pero ahora imagina soltar ese estrés...
            </h3>
            <p className="text-amber-700 mb-6" data-id="element-235">
              No eres desorganizada. No eres floja. Eres una mamá poderosa que
              solo necesita herramientas más inteligentes. Y hoy las tienes
              frente a ti.
            </p>
            <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-amber-600" data-id="element-236">
              <p className="italic text-amber-800" data-id="element-237">
                "Según la American Heart Association, cocinar en casa con
                recetas simples puede reducir hasta 30% el consumo de
                ultraprocesados. Eso significa salud, ahorro y energía real para
                toda la familia."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function PainPoint({
  text
}) {
  return <div className="flex items-start space-x-3" data-id="element-238">
      <CheckCircleIcon className="h-6 w-6 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-239" />
      <p className="text-amber-800" data-id="element-240">{text}</p>
    </div>;
}